export const GenderObjects = [{ value: 1, label: "Муж." }, { value: 2, label: "Жен."}]

const Gender = ["Муж.", "Жен."];

export default Gender;
